import React from "react"
import Head from "next/head"

type props = {
  title: string
  description?: string
  preview?: string
  theme?: string
  children?: React.ReactNode
}

export const PageMeta: React.FC<props> = (props) => {
  return (
    <Head>
      <meta property='og:type' content='website' />
      <meta property='og:url' content='https:/shopruby.app' />
      <meta property='og:site_name' content={"Ruby"} key='ogsitename' />
      <meta name="google-site-verification" content="4ZiRcvVJQJ6zXWQwWwzfZxubem3etTWsJDkWtu_8WwE" />

      {/* Title */}
      <title>{"Ruby - " + props.title}</title>
      <meta property='og:title' content={"Ruby - " + props.title} />

      {/* Description */}
      <meta
        name='description'
        content={props.description ?? "Description for Ruby website"}
      />
      <meta
        property='og:description'
        content={props.description ?? "Description for Ruby website"}
      />

      {/* Link preview */}
      <meta
        name='image'
        content={props.preview ?? "https:/shopruby.app/images/og.jpg"}
      />
      <meta
        property='og:image'
        content={props.preview ?? "https:/shopruby.app/images/og.jpg"}
      />

      {/* Icon */}
      <link rel='icon' type='image/png' href='/favicon.png' />
      <link rel='apple-touch-icon' href='/apple-touch-icon.png' />

      {/* Theme */}
      <meta
        name='theme-color'
        content={props.theme}
        media=' (prefers-color-scheme: light)'
      />
      <meta
        name='theme-color'
        content={props.theme}
        media=' (prefers-color-scheme: dark) '
      />

      {/* Twitter */}
      <meta name='twitter:creator' content={"twitterHandle"} key='twhandle' />
      <meta name='twitter:image' content={"https://shopruby.app/images/link-preview.jpg"} />
      <meta
        name='twitter:card'
        content='Description for Ruby website'
        key='twcard'
      />
      {props.children}
    </Head>
  )
}
